import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Helmet from "react-helmet";
import styled from "@emotion/styled";
import {
  useGetMeQuery,
  useGetPartyQuery,
  useGetPlayerTournamentsStatsLazyQuery,
} from "generated/graphql";
import SideBar from "components/sidebar/Sidebar";
import NavBar from "components/navbar/NavBar";

const ProfilePageWrapper = styled.div`
  /* Top Navbar */

  .profilePic img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }

  /* Side Navbar*/

  .sponsor {
    width: 100;
    height: 30px;
    margin-top: 5px;
    margin-left: -5px;
  }

  .sidebar {
    width: 200px;
    height: 100%;
    background: #701129;
    padding: 30px 0px;
    position: fixed;
  }

  .side-logo {
    width: 100px;
    height: 100px;
    margin-bottom: 15px;
    margin-left: 50px;
    margin-top: -20px;
  }

  .search {
    width: 170px;
    height: 35px;
    margin-left: 15px;
  }

  .sidebar ul {
    list-style-type: none;
    margin-top: -10px;
  }

  .sidebar ul li {
    padding: 15px;
  }

  .sidebar ul li a {
    color: #ffffff;
    display: block;
    text-decoration: none;
    font-weight: bold;
    text-align: center;
    margin-right: 35px;
  }

  /* Profile Info */

  .profile_cover_photo {
    position: relative;
    width: 100%;
    margin-top: -20px;
  }

  .profile_page_pic img {
    position: absolute;
    top: 120px;
    left: 230px;
    width: 140px;
    height: 140px;
  }

  .container2 {
    display: block;
    margin-top: 20px;
    margin-left: 200px;
    height: 320px;
  }

  .profile_trophies {
    position: absolute;
    top: 110px;
    left: 20px;
    font-weight: bold;
    font-size: larger;
    margin-left: 370px;
  }

  .profile_trophies img {
    width: 35px;
    height: 35px;
    margin-top: 10px;
  }

  /* Floating Navbar */

  .float_navbar {
    position: relative;
    overflow: hidden;
    background-color: #1d2029;
    margin-left: 350px;
    margin-right: 150px;
    height: 40px;
    border-radius: 50px;
    margin-top: -70px;
  }

  .float_links a {
    float: none;
    position: relative;
    top: 50%;
    left: 5%;
    top: 12px;
    color: #7d7d7d;
    text-decoration: none;
    font-weight: 600;
  }

  .float_links2 a {
    float: none;
    position: relative;
    top: 50%;
    left: 45%;
    top: -7px;
    color: #7d7d7d;
    text-decoration: none;
    font-weight: 600;
  }

  .float_links3 a {
    float: none;
    position: relative;
    top: 50%;
    left: 87%;
    top: -27px;
    color: #7d7d7d;
    text-decoration: none;
    font-weight: 600;
  }

  /* Table */

  table {
    border-collapse: collapse;
    width: 60%;
    margin-left: 350px;
    margin-top: 50px;
    margin-bottom: 50px;
  }

  td,
  th {
    border: 1px solid #7d7d7d;
    text-align: left;
    padding: 8px;
  }

  th {
    color: #7d7d7d;
  }

  @media (max-width: 858px) {
    /* Side Bar */
    .sidebar {
      width: 0%;
      height: 0%;
    }
    .search {
      display: none;
    }
    .side-logo {
      width: 50px;
      height: 50px;
      margin-top: -7px !important;
      margin-left: 5px;
    }
    .checkbtn {
      background-color: #1d2029;
      width: 70px;
      height: 60px !important;
      display: block;
      float: right;
      margin-right: 0px;
      margin-top: 20px !important;
    }
    .checkbtn i {
      padding-left: 20px;
      padding-right: 20px;
    }
    .sidebar ul {
      position: fixed;
      width: 100%;
      height: 100%;
      background: #701129;
      top: 70px;
      top: -100%;
      text-align: center;
      transition: all 0.5s;
    }
    #check:checked ~ .sidebar ul {
      top: 60px;
    }
    /* Profile Info */
    .profile_cover_photo {
      width: 800px;
      margin-left: -200px;
    }
    .profile_page_pic img {
      top: 70px;
      left: 20px;
    }
    .profile_trophies {
      top: 50px;
      left: 20px;
      font-weight: bold;
      font-size: 17px;
      margin-left: 150px;
    }
    .try2 {
      margin-left: 200px;
      margin-top: -77px;
    }
    .try3 {
      margin-left: 200px;
    }
    /* Floating Navbar */
    .float_navbar {
      width: 95%;
      margin-left: 20px;
      margin-top: -140px;
    }
    /* Match History Table */
    table {
      width: 95%;
      margin-left: 20px;
    }
    /* Trophie Cards */
    .column {
      width: 30%;
    }
    #trophie_cards {
      margin-left: 20px;
    }
  }

  @media (max-width: 440px) {
    /* Profile Info */
    .profile_cover_photo {
      width: 440px;
      height: 140px;
    }
    .profile_page_pic img {
      width: 75px;
      height: 75px;
    }
    .profile_trophies {
      top: 50px;
      left: 20px;
      font-weight: bold;
      font-size: 15px;
      margin-left: 80px;
    }
    /* Floating Navbar */
    .float_navbar {
      width: 90%;
      margin-left: 20px;
      margin-top: -170px;
      border-radius: 20px;
    }
    .float_links3 a {
      left: 77%;
    }
    #team_table {
      width: 90%;
    }
    #team_table td {
      font-size: 12px;
    }
    #team_table img {
      width: 50%;
      padding-left: 10px;
    }
    .column {
      width: 60%;
    }
    #trophie_cards {
      margin-left: 120px;
    }
    .card h3 {
      font-size: 16px;
    }
    .card p {
      font-size: 13px;
    }
  }
`;

function ProfilePage({ isSelf }: { isSelf?: boolean }) {
  // @ts-ignore
  let { username } = useParams();
  const { data, loading } = useGetPartyQuery({
    variables: {
      username,
    },
  });
  const { data: me, loading: isLoadingMe } = useGetMeQuery();

  const [getPlayerStats, { loading: isLoadingStats, data: stats }] =
    useGetPlayerTournamentsStatsLazyQuery();

  // Get participated tournaments stats
  useEffect(() => {
    // Get party tournaments
    let filters: { tournamentId: string; partyId: string }[] | undefined = [];
    if (isSelf) {
      filters = me?.me?.tournament_registrations.map((tourn) => ({
        tournamentId: tourn.id,
        partyId: me.me?.id!,
      }));
    } else {
      filters = data?.party[0].tournament_registrations.map((tourn) => ({
        tournamentId: tourn.id,
        partyId: data?.party[0].id!,
      }));
    }

    if (filters) {
      getPlayerStats({ variables: { params: { filters } } });
    }
  }, [data, me, isSelf, getPlayerStats]);

  let partyDetailsMap = {};
  if (!loading && data?.party[0]) {
    partyDetailsMap = data?.party[0].partyDetails
      .map(({ key, value }: any) => ({
        [key]: value,
      }))
      // @ts-ignore
      .reduce((acc, val) => ({ ...acc, ...val }), {});
  }

  return (
    <ProfilePageWrapper>
      <Helmet>
        {data && (
          <title>
            {data?.party[0].nickname} ({data?.party[0].name}) — Jiwe eSports
          </title>
        )}
      </Helmet>
      <div className="wrapper">
        <SideBar
          nickname={data?.party[0].nickname}
          isLoggedIn={!!data?.party[0].nickname}
        />
        {!isLoadingMe && isSelf && me?.me && (
          <NavBar nickname={me?.me?.nickname} name={me.me?.name} />
        )}
      </div>
      <div className="container2">
        <div className="profile_parent">
          <img className="profile_cover_photo" src={undefined} alt="" />
          <div className="profile_page_pic">
            <img src="/images/Profile_pic_square.png" alt="" />
          </div>
          <div className="profile_trophies">
            <p>
              {data?.party[0].nickname} ({data?.party[0].name})
            </p>
            <p>
              <span style={{ color: "#7D7D7D" }}>Total Points: </span> 0
            </p>
            <p>
              <img src="/images/Gold Trophie.png" alt="" />0 &nbsp;{" "}
              <img src="/images/Silver Trophie.png" alt="" />0 &nbsp;{" "}
              <img src="/images/Bronze Trophie.png" alt="" />0
            </p>
            <div>
              <small>Bio</small>
              <p>
                {
                  // @ts-ignore
                  partyDetailsMap["bio"]
                }
              </p>
            </div>
          </div>
        </div>
      </div>

      {!isLoadingStats && stats && (
        <table>
          <tr>
            <th>Date</th>
            <th>Rank</th>
            <th>Points</th>
          </tr>
          {stats.getPlayerTournamentsStats?.stats.map((stat: any) => {
            if (stat && stat.ranks) {
              return (
                <tr key={stat.id}>
                  <td>{stat.id}</td>
                  <td>{stat.ranks.global.points}</td>
                  <td>{stat.scores.global.points}</td>
                </tr>
              );
            }
            return null;
          })}
        </table>
      )}

      <div className="grid-container5">
        <div className="footer_logos">
          <img className="icon" src="/images/Logo.png" alt="" />
          <img
            className="activision"
            src="/images/Activision_Logo.png"
            alt=""
          />
        </div>
        <div className="footer_links">
          <p>
            SUPPORT &nbsp; TERMS &nbsp; PRIVACY &nbsp; COOKIE POLICY &nbsp;
            COOKIE SETTINGS
          </p>
          <p className="p2">Email us: rock@jiwe.io / social@jiwe.io</p>
          <img
            className="socials"
            src="/images/Social media links.png"
            alt=""
          />
        </div>
      </div>
    </ProfilePageWrapper>
  );
}

export default ProfilePage;
